import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['email', 'submit']

  connect() {
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    const emailValue = this.emailTarget.value.trim()
    const isValid = emailValue.length > 0 && this.isValidEmail(emailValue)
    this.submitTarget.disabled = !isValid
  }

  isValidEmail(value) {
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(value)
  }
}
